export default "__VITE_ASSET__1LUsqaL6__"